import * as Yup from 'yup';

export const validateSchema = Yup.object().shape({
    name: Yup.string().required().min(3).max(100),
    inn: Yup.number().required(),
    kpp: Yup.number().required(),
    ceo: Yup.string().required().min(3).max(100),
    legal_address: Yup.string().required().min(3).max(100),
});

export const validateSchemaRoles = Yup.object().shape({
    name: Yup.string().required()
});

export const validateSchemaProfile = Yup.object().shape({
    phone: Yup.string().required().matches(/^\+7-\d{3}-\d{3}-\d{2}-\d{2}$/),
    email: Yup.string().email().required().matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/),
    password: Yup.string()
        .min(8, 'Пароль должен содержать минимум 8 символов')
        .max(20, 'Пароль должен содержать максимум 20 символов')
        .matches(/[A-Z]/, 'Пароль должен содержать минимум одну заглавную букву')
        .matches(/[0-9]/, 'Пароль должен содержать минимум одну цифру')
        .matches(/[!?#$&@]/, 'Пароль должен содержать минимум один специальный символ (!?#$&@)'),
    user_ad_personal_info: Yup.object().shape({
        first_name: Yup.string().min(2).max(20).required(),
        surname: Yup.string().min(2).max(20).required(),
    }),
});